<template>
    <CardRh :processando="processando">
        <div class="instrutor-pelotao-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span>
                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="pelotao" class="form-label">Pelotao</label>
                        <input id="pelotao" v-model="pelotao" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Numero do pelotao" />
                    </div>

                    <div class="col-12 col-md-6 col-lg-5">
                        <label for="disciplinaFiltro" class="form-label">Disciplina</label>
                        <input id="disciplinaFiltro" v-model="disciplina" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Nome da disciplina" />
                    </div>
                    <div class="col-12 col-lg-4 panel-actions">
                        <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                            Limpar
                        </button> 
                    </div>
                </div>
            </section>

            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" @tableatualizada="tableatualizada($event)"
                    :pesquisar="false">
                    <th>Disciplina</th>
                    <th>Pel</th>
                    <th>Turma</th>
                    <th>Status</th>
                    <th>Inicio da Turma</th>
                    <th class="text-center coluna-acoes" v-if="hasPermissao">Acoes</th>
                </KDataTable>
            </section>
        </div>
    </CardRh>
</template>

<script lang="ts">
import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';
import CardRh from "@/components/cards/ManzaCard.vue";
import InstrutorService from "@/service/v1/sigap/InstrutorService";
import { Options } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";

@Options({
    name: "InstrutorIndex",
    components: { CardRh, KDataTable },
})
export default class InstrutorIndex extends IndexModelTable {
    public cpf: any = null;
    public turmaId: any = null;
    public pelotao = '';
    public disciplina = '';

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.Professor], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.pelotao = '';
        this.disciplina = '';
        this.refreshTable();
    }

    created() {
        this.service = new InstrutorService();
        this.cpf = this.currentUser.id;
        this.turmaId = this.$route.params.turmaId;
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    cpf: this.cpf,
                    pelotao: this.pelotao,
                    disciplina: this.disciplina,
                    turmaId: this.turmaId,
                    search: d.search.value,
                };
                return dados;
            }
        };

        this.config.columns = [
            { data: 'disciplina.descricao', name: 'disciplina.descricao' },
            { data: 'pelotao', name: 'pelotao' },
            { data: 'turma.descricao', name: 'turma.descricao', searchable: false, class: 'desktop text-center' },
            { data: 'turma.status.nome', name: 'turma.status.nome', searchable: false, class: 'desktop text-center' },
            { data: 'turma.turmaInicio', name: 'turma.turmaInicio', searchable: false, class: 'desktop text-center' },
        ];
        this.config.columnDefs = [
            {
                targets: 3,
                render: (row) => {
                    return row.replaceAll('_', ' ');
                }
            },
            {
                targets: 4,
                render: (row) => {
                    return SiteUtils.formatData(row);
                }
            }
        ];
        if (this.hasPermissao) {
            this.config.columns.push({ data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center' });
            this.config.columnDefs.push(
                {
                    targets: 5,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-notas ' + buttom + ' title="Avaliacoes"><i class="fa fa-file-signature "></i></button>';
                        texto = texto + '<button class="btn btn-pmes-warning btn-sm" btn-aulas ' + buttom + ' title="Aulas"><i class="fa fa-chalkboard"></i></button>';
                        return texto;
                    },
                }
            );
        }
    }

    public tableatualizada() {
        $('[btn-notas]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.$router.push({ name: 'instrutor_disciplina_notas', params: { instrutor: id } });
        });
        $('[btn-aulas]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.$router.push({ name: 'instrutor_disciplina_aulas', params: { instrutor: id } });
        });
        $('[btn-aulas-avulsa]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            const pelotao = $(btn.currentTarget).data('pelotao');
            const disciplina_id = $(btn.currentTarget).data('disciplinaId');
            this.$router.push({ name: 'instrutor_disciplina_aulas_avulsa', params: { instrutor: id, pelotao: pelotao, disciplina_id: disciplina_id } });
        });
    }
}
</script>

<style scoped>
.instrutor-pelotao-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.table-panel {
    padding: 0px 10px !important;
}

.panel-heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e9eef5;
}

.panel-heading-table {
    margin-bottom: 5px;
}

.panel-title {
    margin-bottom: 2px;
    color: #102542;
    font-size: 1.05rem;
    font-weight: 800;
}

.panel-description {
    margin-bottom: 0;
    color: #66758c;
    line-height: 1.45;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
    padding: 0.55rem 1.25rem;
}
 

.registro-alteracao {
    text-align: right;
}

@media screen and (min-width: 1200px) {
    .coluna-acoes {
        min-width: 170px;
    }
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .panel-heading {
        flex-direction: column;
    }
    
    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}


.filter-panel {
    position: relative;
    padding-top: 24px;
}


.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}
</style>
